export default function flatGrouppedMap(namespaces: Array<string>, grouppedModules: Record<string, Array<CommonStore<unknown, unknown>>>, modules: Record<string, CommonStore<unknown, unknown>>): Array<CommonStore<unknown, unknown>> {
  let flatModules: Array<CommonStore<unknown, unknown>> = [];

  namespaces.forEach(namespace => {
    if (grouppedModules[namespace]) {
      flatModules = [...flatModules, ...grouppedModules[namespace]];
    } else if (modules[namespace]) {
      flatModules.push(modules[namespace]);
    }
  });

  return flatModules;
}
